import { createFileRoute } from '@tanstack/react-router'
import { loaderScope } from '~/features/people/queries'
import { ComparePage } from '~/features/stats/ComparePage'
import { compareQuery, isCompetition, type Competition } from '~/features/stats/queries'

type Search = { ids?: string; wettbewerb?: Competition }
const UUID = /^[0-9a-f-]{36}$/i
const idsOf = (s: string | undefined) => (s ?? '').split(',').filter((x) => UUID.test(x)).slice(0, 4)

export const Route = createFileRoute('/_app/kader/vergleich')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    ...(typeof s.ids === 'string' && idsOf(s.ids).length ? { ids: idsOf(s.ids).join(',') } : {}),
    ...(isCompetition(s.wettbewerb) && s.wettbewerb !== 'competitive' ? { wettbewerb: s.wettbewerb } : {}),
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId) return
    await context.queryClient
      .ensureQueryData(compareQuery(scope.teamId, scope.season, deps.wettbewerb ?? 'competitive', idsOf(deps.ids)))
      .catch(() => undefined)
  },
  component: function Compare() {
    const s = Route.useSearch()
    return <ComparePage ids={idsOf(s.ids)} competition={s.wettbewerb ?? 'competitive'} />
  },
})
